var PageThumbnailList         = require("./PageThumbnailList"),
    ScrollerDecoratorCarousel = require("app/ui/ScrollerDecoratorCarousel"),
    get                       = require("object-path").get,
    kind                      = require("enyo/kind");

require("./PageThumbnailCarousel.less");

/**
 * [PageThumbnailCarousel]{@link app.MediaPlayer.Tech.ImageReader.PageThumbnailCarousel}
 * is a horizontally scrolling virtualized lists of
 * [PageThumbnails]{@link app.MediaPlayer.Tech.ImageReader.PageThumbnail}.
 *
 * @ui
 * @class   app.MediaPlayer.Tech.ImageReader.PageThumbnailCarousel
 * @extends app.ui.CoverCarousel
 * @public
 */
module.exports = kind(/** @lends  app.MediaPlayer.Tech.ImageReader.PageThumbnailCarousel.prototype */ {

    /**
     * @private
     */
    name: "app.MediaPlayer.Tech.ImageReader.PageThumbnailCarousel",

    /**
     * @private
     */
    kind: ScrollerDecoratorCarousel,

    /**
     * @private
     */
    classes: "app-media-player-image-reader-page-thumbnail-carousel",

    /**
     * The state of this page.
     *
     * @type  {?Object}
     * @private
     */
    state: null,

    /**
     * Selector path used to find the nested
     * [Scroller]{@link enyo-ui.Scroller} control.
     *
     * @type  {string}
     * @public
     */
    scrollerPath: ".$.repeater.$.scroller",

    /**
     * When to show the scrollThumb:
     *  - "always"   Always shows the thumb
     *  - "onscroll" Only shows the thumb when scroller is scrolling
     *  - "never"    Never shows the thumb
     *
     * @type     {string}
     * @default  "onscroll"
     * @public
     */
    showScrollThumb: "onscroll",

    /**
     * @private
     */
    components: [{
        name:           "repeater",
        kind:           PageThumbnailList,
        classes:        "app-ui-repeaters-carousel-row__repeater",
        showItemTitles: true
    }],

    /**
     * @private
     */
    bindings: [{
        from: ".activeIndex",
        to:   ".$.repeater.activeIndex"
    }, {
        from: ".canvasView",
        to:   ".$.repeater.canvasView"
    }],

    /**
     * @private
     */
    observers: {
        update: ["state"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);
            this.update();
        };
    }),

    /**
     * @protected
     */
    update: function() {
        var state = this.state || {},
            pages = get(state, "watchingSession.urls.hq.path", []);

        this.$.repeater.set("data", pages);
    }

});
